<template>
  <v-bottom-sheet inset v-model="sheet" :max-width="sheetMaxWidth">
    <v-sheet
      height="90vh"
      class="suus__form-sheet"
      elevation="1"
      :style="sheetStyles"
    >
      <div class="d-flex justify-end">
        <v-btn class="mt-4 mr-4" icon color="textColor" @click="closeSheet">
          <v-icon>{{ closeIcon }}</v-icon>
        </v-btn>
      </div>
      <slot></slot>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script lang="ts">
import Vue from "vue"
import Button from "./Button.vue"
import { mdiClose } from "@mdi/js"

export default Vue.extend({
  name: "Sheet",
  components: { Button },
  props: {
    showSheet: { type: Boolean, default: false, required: true },
  },
  data() {
    return {
      closeIcon: mdiClose,
    }
  },
  computed: {
    sheet: {
      get(): boolean {
        return this.showSheet
      },
      set(value: boolean) {
        this.$emit("changeVisibility", value)
      },
    },
    sheetStyles(): object {
      return {
        overflowY: "scroll",
        borderRadius: `4px 4px 0 0 !important`,
        borderTop: `10px solid ${this.$vuetify.theme.themes.light.primary}`,
      }
    },
    sheetMaxWidth(): string {
      return this.$vuetify.breakpoint.name === "sm" ? "90%" : "auto"
    },
  },
  methods: {
    closeSheet() {
      this.sheet = false
    },
  },
})
</script>

<style lang="sass" scoped></style>
